import qs from "qs";
import { GetData, GetDataV2 } from "./Functions/SettingData";
import { combineWithUnderscore } from "../Helper/Formatters/TextFormatter";
import { convertZonetoUTC, convertZonetoUTCEnd, convertZonetoUTCStart } from "../Helper/DatePicker/DateConverter";
import { getBmsFaultErrorCodesHeader } from "./Functions/BmsFaultHeader";

async function getBatteryHierarchy(batteryID) {
  var config = {
    method: "get",
    url: `/api/digital_twin/battery_config/v2/${batteryID}`,
    headers: {
      "Content-Type": "application/json",
    }
  };

  let data = GetData(config);
  return data;
}

async function getBatteryHierarchyV3(batteryID, entityTypes = ['BATTERY_STRUCTURE', 'BATTERY_SYSTEM']) {
  const entityTypeList = entityTypes.join(",");
  var config = {
    method: "get",
    url: `/api/digital_twin/battery_config/v3/${batteryID}`,
    params: {
      entity_type_list: entityTypeList,
    },
    headers: {
      "Content-Type": "application/json",
    },
  };

  let data = GetData(config);
  return data;
}

async function getRealtimeKPI(batteryID, pack, module, cell, level) {
  let rawJson = {
      batteryID: batteryID,
      packID: level === "pack" ? combineWithUnderscore(batteryID, pack, module, cell) : "",
      moduleID: level === "module" ? combineWithUnderscore(batteryID, pack, module, cell) : "",
      cellID: level === "cell" ? combineWithUnderscore(batteryID, pack, module, cell) : "",
      level: level
    }; 
  var config = {
    method: "get",
    url: `/api/digital_twin/real_time`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson
  };

  let data = GetData(config);
  return data;
}

async function getChargerData(batteryID) {
  let rawJson = {
    batteryID: batteryID
  }
  var config = {
    method: "get",
    url: `/api/digital_twin/charger_data`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
  };

  let data = GetData(config);
  return data;
}

async function getChargerLogData(batteryID, packConfigID, startTime, endTime, resampleSeconds) {
  let rawJson = {
    batteryID,
    packConfigID,
    startTime : convertZonetoUTCStart(startTime),
    endTime : convertZonetoUTCEnd(endTime),
    resampleSeconds: resampleSeconds
  }
  var config = {
    method: "get",
    url: `/api/digital_twin/charger_logs`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
  };

  let data = GetData(config);
  return data;
}

async function getBatteryVitals(batteryID, pack, module, cell, level,date) {
  let rawJson = {
      batteryID: batteryID,
      packID: level === "pack" ? combineWithUnderscore(batteryID, pack, module, cell) : "",
      moduleID: level === "module" ? combineWithUnderscore(batteryID, pack, module, cell) : "",
      cellID: level === "cell" ? combineWithUnderscore(batteryID, pack, module, cell) : "",
      level: level,
      startTime : convertZonetoUTCStart(date[0]),
      endTime : convertZonetoUTCEnd(date[1])
    }; 
  var config = {
    method: "get",
    url: `/api/digital_twin/battery_vitals`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    // paramsSerializer: (params) =>
    //   qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = GetData(config);
  return data;
}

async function getPackComparision(batteryID, pack, module, cell, level, value, date) {
  let rawJson = {
    "type":level ,
    "columns":[value],
    cellNo: cell ? cell.substring(1) : "",
    packNo: pack ? pack.substring(1) : "",
    moduleNo:  module ? module.substring(1) : "",
    //  packID: level === "pack" ? combineWithUnderscore(batteryID, pack, module, cell) : "",
    //  moduleID: level === "module" ? combineWithUnderscore(batteryID, pack, module, cell) : "",
    //  cellID: level === "cell" ? combineWithUnderscore(batteryID, pack, module, cell) : "",
    "batteryID":batteryID,
    startTime : convertZonetoUTCStart(date[0]),
    endTime : convertZonetoUTCEnd(date[1]),
    "resampleSeconds":300
  };
  var config = {
    method: "get",
    url: `/api/digital_twin/battery_metrics_combined/v3`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = GetData(config);
  return data;
}

async function getPackComparisionV4(batteryID, systemID, level, value, date, resampleSeconds, signal = null) {

  if(level.toLowerCase() === "bus") {
    level = "vehicle";
  }

  let startTime = date[0];
  let endTime = date[1];

  // When start equals end, treat it as a full-day request and expand to 00:00:00 - 23:59:59
  // Otherwise, use the explicit timestamps for zoomed or custom ranges.
  if (startTime === endTime) {
    startTime = convertZonetoUTCStart(startTime);
    endTime = convertZonetoUTCEnd(endTime);
  } else {
    startTime = convertZonetoUTC(startTime);
    endTime = convertZonetoUTC(endTime);
  }

  let rawJson = {
    "type": level,
    "columns":[value],
    cellNo: level === "cell" ? systemID : null,
    packNo: level === "pack" ? systemID : null,
    moduleNo: level === "module" ? systemID : null,
    ...(level === "string" && { stringNum: systemID }),
    ...(level === "vehicle" && { vehicleID: systemID }),
    "batteryID": batteryID,
    startTime: startTime,
    endTime: endTime,
    "resampleSeconds": resampleSeconds
  };  

  var config = {
    method: "get",
    url: `/api/digital_twin/battery_metrics_combined/v4`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  if (signal) {
      config.signal = signal
  }

  let data = GetDataV2(config);
  return data;
}

async function getPackComparisionV5(batteryID, systemIDs, level, value, date, resampleSeconds, signal = null) {
  if (level.toLowerCase() === "bus") {
    level = "vehicle";
  }

  let startTime = date[0];
  let endTime = date[1];

  if (startTime === endTime) {
    startTime = convertZonetoUTCStart(startTime);
    endTime = convertZonetoUTCEnd(endTime);
  } else {
    startTime = convertZonetoUTC(startTime);
    endTime = convertZonetoUTC(endTime);
  }

  let rawJson = {
    type: level,
    columns: [value],
    cellNo: level === "cell" ? systemIDs : null,
    packNo: level === "pack" ? systemIDs : null,
    moduleNo: level === "module" ? systemIDs : null,
    ...(level === "string" && { stringNum: systemIDs }),
    ...(level === "vehicle" && { vehicleID: systemIDs[0] }),
    batteryID: batteryID,
    startTime: startTime,
    endTime: endTime,
    resampleSeconds: resampleSeconds,
  };

  var config = {
    method: "get",
    url: `/api/digital_twin/battery_metrics_combined/v5`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  if (signal) {
    config.signal = signal;
  }

  let data = GetDataV2(config);
  return data;
}

async function getGranularityDataV3(batteryID, systemIDs, level, value, date, granular, operation, signal = null) {
  let rawJson = {
    type: level,
    cellNo: level === "cell" ? systemIDs : null,
    packNo: level === "pack" ? systemIDs : null,
    moduleNo: level === "module" ? systemIDs : null,
    ...(level === "string" && { stringNum: systemIDs }),
    ...(level === "vehicle" && { vehicleID: systemIDs[0] }),
    columns: value,
    startTime: convertZonetoUTCStart(date[0]),
    endTime: convertZonetoUTCEnd(date[1]),
    batteryID: batteryID,
    granularity: granular,
    operation: operation,
  };

  var config = {
    method: "get",
    url: `/api/digital_twin/battery_vitals_trend/v3`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  if (signal) {
    config.signal = signal;
  }

  let data = GetData(config, true);
  return data;
}

async function getChargerVitals(batteryID, value, date) {
  let rawJson = {

    "columns":value,
    "batteryID":batteryID,
    "resampleSeconds":300,
    startTime : convertZonetoUTCStart(date[0]),
    endTime : convertZonetoUTCEnd(date[1])
  };
  var config = {
    method: "get",
    url: `/api/digital_twin/charger_vitals`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = GetData(config);
  return data;
}

async function getColorMapping(batteryID) {
  let rawJson = {

    "batteryID":batteryID,
  };
  var config = {
    method: "get",
    url: `/api/digital_twin/battery_info`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = GetData(config);
  return data;
}

async function getGranularityData(
  batteryID,
  pack,
  module,
  cell,
  level,
  value,
  date,
  granular,
  operation
) {
  let rawJson = {
    type: level,
    cellNo: cell?.substring(1),
    packNo: pack?.substring(1),
    moduleNo:  module?.substring(1),
    columns: value,
    startTime: convertZonetoUTCStart(date[0]),
    endTime: convertZonetoUTCEnd(date[1]),
    batteryID: batteryID,
    granularity: granular,
    operation: operation,
  };
  var config = {
    method: "get",
    url: `/api/digital_twin/battery_vitals_trend`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = GetData(config,true);
  return data;
}

async function getGranularityDataV2(
  batteryID,
  systemID,
  level,
  value,
  date,
  granular,
  operation,
  signal = null
) {
  let rawJson = {
    type: level,
    cellNo: level === "cell" ? systemID : null,
    packNo: level === "pack" ? systemID : null,
    moduleNo: level === "module" ? systemID : null,
    ...(level === "string" && { stringNum: systemID }),
    ...(level === "vehicle" && { vehicleID: systemID }),
    columns: value,
    startTime: convertZonetoUTCStart(date[0]),
    endTime: convertZonetoUTCEnd(date[1]),
    batteryID: batteryID,
    granularity: granular,
    operation: operation,
  };
  var config = {
    method: "get",
    url: `/api/digital_twin/battery_vitals_trend/v2`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  if (signal) {
    config.signal = signal;
  }

  let data = GetData(config,true);
  return data;
}

async function getChargerGranularityData(
  batteryID,
  columns,
  date,
  granular,
  operation
) {
  //batteryID,pack,module,cell,level,date,granular
  let rawJson = {
    columns: columns,
    startTime: convertZonetoUTCStart(date[0]),
    endTime: convertZonetoUTCEnd(date[1]),
    batteryID: batteryID,
    granularity: granular,
    operation: operation,
  };
  var config = {
    method: "get",
    url: `/api/digital_twin/charger_vitals_trend`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = GetData(config,true);
  return data;
}

async function getBatteryHierarchicalAlertsCount(batteryID) {
  var rawJson = {
    startDate: null,
    endDate: null,
  };

  var config = {
    method: "get",
    url: `/api/digital_twin/dashboard/${batteryID}/hierarchical_alerts_count`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = GetData(config);
  return data;
}

async function getAlertsByGroup(fields, batteryID) {
  var rawJson = {
    status: fields?.status === "" ? "" : fields?.status || "",
    severity: fields?.severity === "" ? "" : fields?.severity || "",
    order: fields?.order === "" ? "" : fields?.order || "",
    sortBy: fields?.sortBy === "" ? "" : fields?.sortBy || "",
    startDate: fields?.startDate === "" ? "" : convertZonetoUTCStart(fields?.startDate) || "",
    endDate: fields?.endDate === "" ? "" : convertZonetoUTCEnd(fields?.endDate) || "",
  };

  var config = {
    method: "get",
    url: `api/digital_twin/dashboard/${batteryID}/digital_twin_alerts`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = GetData(config);
  return data;
}


async function getRealTimeInfo(batteryID, params = {}) {
  var config = {
    method: "get",
    url: `/api/digital-twin/${batteryID}/real-time-info`,
    params: params,
    headers: {
      "Content-Type": "application/json",
    },
  };

  let response = await GetData(config, true);
  return response.response;
}

async function getDigitalTwinBatteryTags(batteryID, params = {}) {
  var config = {
    method: "post",
    url: `/api/digital-twin/${batteryID}/tags`,
    data: params,
    headers: {
      "Content-Type": "application/json",
      ...getBmsFaultErrorCodesHeader(),
    },
  };

  let response = await GetData(config);
  return response.response;
}

async function getDigitalTwinRealTimeMatrics(batteryID, params = {}) {
  var config = {
    method: "get",
    url: `/api/digital-twin/${batteryID}/real-time-matrix`,
    params: params,
    headers: {
      "Content-Type": "application/json",
    },
  };

  let response = await GetData(config);
  return response.response;
}


async function getDigitalTwinStructure(batteryID) {
  let rawJson = { "batteryID": batteryID};
  var config = {
    method: "get",
    url: `/api/digital_twin/battery_info`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetData(config);
  return data;
}


async function getDigitalTwinAlerts(reqParams = {}, page = 1) {
  var config = {
    method: "get",
    url: `/api/alert/alerts_item_list/v2/${page}`,
    headers: {
      "Content-Type": "application/json",
    },
    params: reqParams,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetData(config);
  return data;
}


const getAlertInfo = async (alertId) => {
  var config = {
    method: "get",
    url: `/api/alert/info/${alertId}`,
    headers: {
      "Content-Type": "application/json",
    },
    params: {},
  };
  let data = GetData(config);
  return data;
};

async function getBatteryIndicators(batteryID, indicatorProfile) {
  var config = {
    method: "get",
    url: `/api/digital-twin/${batteryID}/indicators`,
    headers: {
      "Content-Type": "application/json",
    },
    // Send the profile name only when configured; absence makes the backend
    // fall back to the org-wide ping threshold (current behaviour).
    ...(indicatorProfile && { params: { indicatorProfile } }),
  };

  let data = GetData(config);
  return data;
}

async function getBatteryStrings(batteryID) {
  var config = {
    method: "get",
    url: `/api/batteries/${batteryID}/strings`,
    headers: {
      "Content-Type": "application/json",
    }
  };

  let data = GetData(config);
  return data;
}

async function getBatterySignals(batteryID, entityType) {
  var config = {
    method: "get",
    url: `/api/digital_twin/battery_config/v3/${batteryID}/entity/${entityType}/signals`,
    headers: {
      "Content-Type": "application/json",
    }
  };

  let data = GetData(config);
  return data;
}

async function getBatteryColumns(batteryID) {
  var config = {
    method: "get",
    url: `/api/digital_twin/battery_info/columns`,
    params: {batteryID: batteryID},
    headers: {
      "Content-Type": "application/json",
    }
  };

  let data = GetData(config);
  return data;
}

async function getBatteryColumnsData(batteryID, entityTypeList = "BATTERY_SYSTEM") {
  var config = {
    method: "get",
    url: `/api/digital_twin/battery_info`,
    params: { batteryID: batteryID, entity_type_list: entityTypeList },
    headers: {
      "Content-Type": "application/json",
    }
  };

  let data = GetData(config);
  return data;
}

async function getDigitalTwinHistory(batteryID) {
  var config = {
    method: "get",
    url: `/api/battery/${batteryID}/history`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  let data = GetData(config);
  return data;
}

async function getDigitalTwinTagsHistory(batteryID, tagName = 'status') {
  var config = {
    method: "get",
    url: `/api/v1/entities/battery/${batteryID}/tags/${tagName}/history`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  let data = GetData(config);
  return data;
}

async function updateDigitalTwinDetails(batteryID, data) {
  var config = {
    method: "post",
    url: `/api/digital-twin/${batteryID}/update-details`,
    data,
    headers: {
      "Content-Type": "application/json",
    },
  };

  let response = await GetDataV2(config);
  return response;
}

export {
  getBatteryHierarchy,
  getBatteryHierarchyV3,
  getRealtimeKPI,
  getBatteryVitals,
  getPackComparision,
  getPackComparisionV4,
  getPackComparisionV5,
  getChargerData,
  getChargerVitals,
  getChargerLogData,
  getColorMapping,
  getGranularityData,
  getGranularityDataV2,
  getGranularityDataV3,
  getChargerGranularityData,
  getBatteryHierarchicalAlertsCount,
  getAlertsByGroup,
  getRealTimeInfo,
  getDigitalTwinBatteryTags,
  getDigitalTwinRealTimeMatrics,
  getDigitalTwinStructure,
  getDigitalTwinAlerts,
  getAlertInfo,
  getBatteryIndicators,
  getBatteryStrings,
  getBatterySignals,
  getBatteryColumns,
  getBatteryColumnsData,
  getDigitalTwinHistory,
  getDigitalTwinTagsHistory,
  updateDigitalTwinDetails,
};
